import React from 'react';

export const AllQuestionsImage = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.5 15H16.5V12H1.5V15ZM3 12.75H4.5V14.25H3V12.75ZM1.5 3V6H16.5V3H1.5ZM4.5 5.25H3V3.75H4.5V5.25ZM1.5 10.5H16.5V7.5H1.5V10.5ZM3 8.25H4.5V9.75H3V8.25Z" fill="#197878" />
    </svg>
  );
};
